export default Events =
  Change:
    'change'
  ChangeSuccess:
    'change-success'
  ChangeFailed:
    'change-failed'
